module.exports = __webpack_public_path__ + "img/enter.39d05a9e.svg";